import React, { useEffect, useRef, useState } from "react";
import {
  FaqAccordion as AccordionRoot,
  FaqAccordionItem,
  FaqAccordionTrigger,
  FaqAccordionPanel,
  FaqAnswer,
} from "./Faq.styles";

const FaqAccordionRow = ({ item, sectionId, index, isOpen, onToggle }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);
  const panelId = `${sectionId}-panel-${index}`;
  const triggerId = `${sectionId}-trigger-${index}`;

  useEffect(() => {
    if (!contentRef.current) return;
    setHeight(isOpen ? contentRef.current.scrollHeight : 0);
  }, [isOpen, item.a]);

  return (
    <FaqAccordionItem>
      <FaqAccordionTrigger
        id={triggerId}
        type="button"
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={onToggle}
      >
        {item.q}
        <span className="material-icons" aria-hidden="true">
          expand_more
        </span>
      </FaqAccordionTrigger>
      <FaqAccordionPanel
        id={panelId}
        role="region"
        aria-labelledby={triggerId}
        $open={isOpen}
        style={{ maxHeight: isOpen ? `${height}px` : "0px" }}
      >
        <FaqAnswer ref={contentRef}>
          {item.a.map((paragraph, pIndex) => (
            <p key={pIndex}>{paragraph}</p>
          ))}
        </FaqAnswer>
      </FaqAccordionPanel>
    </FaqAccordionItem>
  );
};

const FaqAccordion = ({ sectionId, items, defaultOpenIndex = null }) => {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);

  return (
    <AccordionRoot>
      {items.map((item, index) => (
        <FaqAccordionRow
          key={item.q}
          item={item}
          sectionId={sectionId}
          index={index}
          isOpen={openIndex === index}
          onToggle={() =>
            setOpenIndex((current) => (current === index ? null : index))
          }
        />
      ))}
    </AccordionRoot>
  );
};

export default FaqAccordion;
